module.exports = __webpack_public_path__ + "static/img/sjss-center.b9d38ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/sjss-center.png
// module id = bynh
// module chunks = 1